import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { ComponentLayout } from '../../../components/layouts/ComponentLayout'
import { BodyLarge, Title2, Title4 } from '../../../components/styles/Typography'
import { theme } from '../../../theme/theme'
import { useGetPortalGeneralPageById } from '../../../api/contentful/contentfulQueries'
import { LoadingSpinner } from '../../../components/LoadingSpinner'
import { PreviewGuard } from '../../../components/PreviewGuard'
import { isILinkList } from '@estercare/ester-shared'
import { SupportBlock } from '../../../components/SupportBlock'
import { CONTENTFUL_ENTRY_IDS } from '../../../constants/contentfulEntries'

export const AdminSupportIndex = () => {
  const { t } = useTranslation()
  const { data: supportPage, isLoading } = useGetPortalGeneralPageById(CONTENTFUL_ENTRY_IDS.SUPPORT_ADMIN)
  if (isLoading) return <LoadingSpinner />

  const supportContent = supportPage?.fields
  if (!supportContent) return <PreviewGuard />

  const { title, description, contentBlocks } = supportContent

  return (
    <>
      <ComponentLayout>
        <StyledTitle2>{title}</StyledTitle2>
        <StyledBodyLarge>{description}</StyledBodyLarge>
      </ComponentLayout>
      {contentBlocks && (
        <ComponentLayout paddingTop={0}>
          {contentBlocks.map((block, index) => {
            return isILinkList(block) && <SupportBlock key={index} linkList={block.fields} />
          })}
        </ComponentLayout>
      )}
      <ComponentLayout paddingTop={0}>
        <OtherQuestions>
          <Title4>{t('admin.support.questionsTitle')}</Title4>
          <StyledBodyLarge>
            {t('admin.support.contactMessage')}{' '}
            <a href="mailto:hello@estercare.com" target="_blank" rel="noreferrer">
              {t('admin.support.contactEmail')}
            </a>{' '}
            {t('admin.support.contactContinue')}
          </StyledBodyLarge>
        </OtherQuestions>
      </ComponentLayout>
    </>
  )
}

const StyledTitle2 = styled(Title2)`
  margin-bottom: ${theme.spacing.xsmall}px;
`

const OtherQuestions = styled.div`
  background-color: ${theme.color.beigeDark};
  padding: ${theme.spacing.xlarge}px;
  border-radius: ${theme.spacing.medium}px;
`

const StyledBodyLarge = styled(BodyLarge)`
  max-width: 640px;
  a {
    color: ${theme.color.plumMid};
    font-weight: 500;
  }
`
